export default "__VITE_ASSET__bc481471__"